// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.recommendation-item{list-style:none;flex-shrink:0;width:250px;min-height:310px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;border:1px solid #feefec;border-radius:12px;background-color:transparent;transition:border-color .1s ease;box-sizing:border-box}.recommendation-item:hover{border-color:#fee2dd}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
